const ENG = {
  slogan: "Your partner in WEB development",
  about_us_text_1:
    "Babri Software is a company that focuses on providing the best Web development services. We are a small, experienced and focused team, founded by two engineers, fully remote based in Latvia.",
  about_us_text_2:
    "We strive for the feeling that you get after a job well-done and this concept is on what we base our company’s purpose — to work with our clients for a result that they would be happy to tell others about.",
  about_us_text_3:
    "We pride ourselves on being <b>React</b> experts. We've done it all - from building simple landing pages to being part of large complex frontend applications with multiple teams.",
  homepage_text:
    "Virtual presence in today's business environment is crucial to any kind of business - it builds trust and gives people confidence. We are here to help companies create a safe, convenient virtual environment that will attract more and more customers so that companies can grow and become more successful.",
  about_us: "about us",
  contacts: "contacts",
  language: "EN",
  web_app: "web app",
  web_app_text:
    "We believe that monitoring of various business processes, tracking KPIs, management of the production process, etc., is the basis of a successful company. We are here to help you create these digital systems as well as be your partner in creating other non - standard web solutions.",
  error_404: "Error 404 - Page not found",
  e_commerce: "e-commerce",
  e_commerce_text:
    "The ability to buy products and services online is no longer just a nice thing for a company to have but an integral part of small and medium-sized businesses. From the sale of shirts to plant seedlings - everyone needs a suitable online shop - we are here to help you make it happen.",
  homepage: "homepage",
  dev: "development",
  babri_explanation:
    "The two founders (brothers) of the company who stand by the quality of the work they do",
  home_description:
    "Babri Software is a company that focuses on providing the best Web development services. We are a small, experienced and focused team, founded by two engineers, fully remote based in Latvia.",
  contact_text_1: "Looking forward to work on new projects!",
  contact_text_2: "Use our direct contacts to get in touch with us.",
  crn: "CRN",
  bank: "Bank",
  bank_account: "Bank account",
  portfolio: "Trusted By",
  technologies: "technologies",
  services: "services",
  contact_us: "contact us",
  competences: "Core Competencies",
  engagement_models: "Engagement models",
  end_to_end: "Fixed project",
  support: "Consulting",
  contract_work: "Contract work",
  requirements: "Requirement gathering",
  design: "Design (UI/UX)",
  development: "Development",
  deployment: "Deployment",
  maintanance: "Maintanance",
  agile: "Agile or fixed-scope",
  maintenance_sys: "Maintenance",
  create: "Create new features",
  update: "Update existing features",
  bugs: "Fixing bugs & issues",
  monitoring: "System monitoring",
  contracts: "Flexible contracts",
  full_time: "Hire full-time",
  part_time: "Hire part-time",
  team: "Part of your team",
  individual: "Work individually",
  jobs: "Jobs",
  training: "Training",
  best_practises: "Guide on best practices",
  audit: "Audit",
  mentor: "Mentoring",
};

export default ENG;
